const channels = [
  {
    icon: 'ri-mail-send-line',
    title: 'Email Support',
    detail: 'support@adforgeai.app',
    note: 'Typical reply within 4 hours',
    href: 'mailto:support@adforgeai.app',
  },
  {
    icon: 'ri-time-line',
    title: 'Support Hours',
    detail: 'Mon – Fri, 8am – 8pm EST',
    note: 'We monitor inboxes on weekends too',
    href: null,
  },
  {
    icon: 'ri-question-answer-line',
    title: 'Help Center',
    detail: 'Browse our docs & guides',
    note: 'Answers to the most common questions',
    href: '#',
  },
];

const socials = [
  { icon: 'ri-facebook-fill', label: 'Facebook', href: 'https://www.facebook.com/profile.php?id=61575473528873', username: 'AdForge AI' },
  { icon: 'ri-instagram-fill', label: 'Instagram', href: 'https://www.instagram.com/ad_forgeai', username: '@ad_forgeai' },
];

const faqs = [
  {
    q: 'How long does it take to get a reply?',
    a: 'Most emails are answered within 4 business hours. On weekends we aim for same-day.',
  },
  {
    q: 'I have a billing issue — what do I do?',
    a: 'Select "Billing & Plans" in the contact form and we\'ll prioritize your message. We can also issue refunds within 7 days.',
  },
  {
    q: 'Can I request a feature?',
    a: 'Absolutely — select "Feature Request" and describe what you\'d love to see. Our product team reads every one.',
  },
  {
    q: 'Do you offer live chat?',
    a: 'Not yet, but it\'s on the roadmap! For now email is the fastest way to reach us.',
  },
];

export default function ContactInfo() {
  return (
    <div className="flex flex-col gap-8">
      {/* Contact channels */}
      <div className="bg-white rounded-2xl border border-stone-100 p-8">
        <h2 className="text-base font-black text-stone-900 mb-6">Other ways to reach us</h2>
        <div className="flex flex-col gap-5">
          {channels.map((c) => (
            <div key={c.title} className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-orange-50 border border-orange-100 shrink-0">
                <i className={`${c.icon} text-orange-500 text-lg`} />
              </div>
              <div>
                <div className="text-sm font-bold text-stone-800 mb-0.5">{c.title}</div>
                {c.href ? (
                  <a
                    href={c.href}
                    className="text-sm text-orange-500 hover:text-orange-600 font-medium transition-colors duration-200"
                  >
                    {c.detail}
                  </a>
                ) : (
                  <div className="text-sm text-stone-600 font-medium">{c.detail}</div>
                )}
                <div className="text-xs text-stone-400 mt-0.5">{c.note}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Social links */}
      <div className="bg-white rounded-2xl border border-stone-100 p-8">
        <h2 className="text-base font-black text-stone-900 mb-6">Find us on social</h2>
        <div className="flex flex-col gap-4">
          {socials.map((s) => (
            <a
              key={s.label}
              href={s.href}
              rel="nofollow"
              className="flex items-center gap-3 group cursor-pointer"
            >
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-stone-100 text-stone-500 group-hover:bg-orange-500 group-hover:text-white transition-all duration-200">
                <i className={`${s.icon} text-sm`} />
              </div>
              <div>
                <div className="text-sm font-semibold text-stone-700 group-hover:text-orange-500 transition-colors duration-200">{s.label}</div>
                <div className="text-xs text-stone-400">{s.username}</div>
              </div>
              <i className="ri-arrow-right-line text-xs text-stone-300 group-hover:text-orange-400 ml-auto transition-colors duration-200" />
            </a>
          ))}
        </div>
      </div>

      {/* Mini FAQ */}
      <div className="bg-white rounded-2xl border border-stone-100 p-8">
        <h2 className="text-base font-black text-stone-900 mb-6">Quick answers</h2>
        <div className="flex flex-col divide-y divide-stone-100">
          {faqs.map((item) => (
            <div key={item.q} className="py-4 first:pt-0 last:pb-0">
              <div className="text-sm font-bold text-stone-800 mb-1">{item.q}</div>
              <div className="text-xs text-stone-500 leading-relaxed">{item.a}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
